import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";
import ProjectOne from "../component/project/ProjectOne";
import BcrumbBannerSmartTech from "../elements/breadcrumb/BcrumbBannerSmartTech";

const SmartTech = () => {
  return (
    <>
      <SEO title="Smart Tech" />
      <main className="main-wrapper">
        <HeaderOne />
        <BcrumbBannerSmartTech
          title="Embracing Technology for Advanced Facilities Management in the UAE"
          paragraph="In today’s fast-paced world, technology is revolutionizing the way facilities are managed, and the UAE is at the forefront of adopting these innovations. The integration of smart technologies in facilities management not only enhances operational efficiency but also promotes sustainability, reduces costs, and improves the overall user experience. At UCWF, we are committed to leveraging cutting-edge technology to deliver superior facilities management services that meet the evolving demands of businesses and industries in the UAE."
          styleClass=""
          page="Smart-Tech"
          titleCategory="Smart Tech"
          mainThumb={[
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-1.webp" },
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-2.webp" },
            { mainThumb: "/images/smartTechucwf/ucwf-mobile-3.webp" },
          ]}
          color=""
        />
        <ProjectOne
          title=""
          subtitle=""
          isHomePage={false}
          isSmartTech={true}
        />

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default SmartTech;
